<aside class="sidebar" [class.collapsed]="menuColapsado">
  <div class="sidebar-top">
    <div class="brand">
      <div class="brand-line"></div>
      <div class="brand-text" aria-label="Agencia Nacional de Investigaci&oacute;n y Desarrollo">
        <span>Agencia Nacional de</span>
        <span>Investigaci&oacute;n y Desarrollo</span>
      </div>
    </div>

    <button
      type="button"
      class="sidebar-toggle"
      (click)="alternarMenu()"
      [attr.aria-expanded]="!menuColapsado"
      [attr.aria-label]="menuColapsado ? 'Expandir men&uacute; lateral' : 'Contraer men&uacute; lateral'"
      [title]="menuColapsado ? 'Expandir men&uacute;' : 'Contraer men&uacute;'"
    >
      <lucide-angular [name]="menuColapsado ? 'panel-left-open' : 'panel-left-close'"></lucide-angular>
    </button>
  </div>

  <nav [attr.aria-label]="menuColapsado ? 'Men&uacute; lateral contra&iacute;do' : 'Men&uacute; lateral'">
    <ul>
      <ng-container *ngFor="let item of menu">
        <li
          *ngIf="item.action !== 'logout'; else logoutItem"
          [routerLink]="item.route"
          [queryParams]="queryParamsFor(item)"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          [title]="menuColapsado ? item.label : null"
        >
          <span class="icon">
            <img *ngIf="item.iconAsset; else lucideIcon" class="icon-img" [src]="item.iconAsset" alt="" aria-hidden="true" />
            <ng-template #lucideIcon>
              <lucide-angular [name]="item.icon"></lucide-angular>
            </ng-template>
          </span>
          <span class="label">{{ item.label }}</span>
        </li>

        <ng-template #logoutItem>
          <li (click)="abrirModalCerrarSesion(item)" [title]="menuColapsado ? item.label : null">
            <span class="icon">
              <img *ngIf="item.iconAsset; else logoutLucideIcon" class="icon-img" [src]="item.iconAsset" alt="" aria-hidden="true" />
              <ng-template #logoutLucideIcon>
                <lucide-angular [name]="item.icon"></lucide-angular>
              </ng-template>
            </span>
            <span class="label">{{ item.label }}</span>
          </li>
        </ng-template>
      </ng-container>
    </ul>
  </nav>
</aside>

<div class="logout-modal-backdrop" *ngIf="modalCerrarSesionVisible">
  <div class="logout-modal" role="dialog" aria-modal="true" aria-label="Confirmar cierre de sesi&oacute;n">
    <h3>Cerrar sesi&oacute;n</h3>
    <p>&iquest;Deseas cerrar sesi&oacute;n y salir de la plataforma?</p>
    <div class="logout-actions">
      <button type="button" class="btn-cancel" (click)="cancelarCerrarSesion()">Cancelar</button>
      <button type="button" class="btn-confirm" (click)="confirmarCerrarSesion()">Confirmar</button>
    </div>
  </div>
</div>
